// apps/admin/src/hooks/useAllAdvertisements.ts

import { ApiResponse, AdvertisementWithMedia } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'
import { useViewMode } from '@/stores/viewMode'

interface UseAllAdvertisementsParams {
  /**
   * 過濾啟用狀態：
   * - undefined（沒帶）→ 全用（啟用 + 停用）
   * - true → 只回啟用
   * - false → 只回停用
   */
  isActive?: boolean
}

export function useAllAdvertisements(params: UseAllAdvertisementsParams = {}) {
  const { token } = useAuth()
  // When drilled into a provider (sys_admin in provider mode), pass providerId so
  // the backend can scope to that provider. Provider users get auto-scoped.
  const { mode, id: viewModeId } = useViewMode()
  const providerId = mode === 'provider' && viewModeId ? viewModeId : undefined

  const queryParams = new URLSearchParams()
  if (providerId) queryParams.set('providerId', String(providerId))
  if (params.isActive !== undefined) queryParams.set('isActive', String(params.isActive))
  const query = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data, error, mutate, isLoading } = useGet<ApiResponse<AdvertisementWithMedia[]>>(
    token ? `/api/advertisements/all${query}` : null,
    undefined,
    token ?? '',
  )

  return {
    advertisements: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
